import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as zc from '@dvsl/zoomcharts';

@Component({
  selector: 'app-facetchart',
  templateUrl: './facetchart.component.html',
  styleUrls: ['./facetchart.component.css']
})

export class FacetchartComponent implements AfterViewInit {

  @Input() chartID: string;
  @Input() settings: string;
  zc: any = zc;
  chart: any;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const FacetChart = this.zc.FacetChart;
    this.chart = new FacetChart(this.settings);
  }

}
